var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"btn",class:[
		_vm.btnColorClass,
		_vm.outline,
		_vm.btnTextColorClass
	],style:(_vm.styleObj),attrs:{"type":"button","disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('div',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}):_vm._e(),(!_vm.loading)?_c('div',{staticClass:"btn-text"},[(_vm.btnImageUrl)?_c('img',{staticClass:"iconify",class:{ 'has-margin': _vm.title },attrs:{"src":_vm.btnImageUrl}}):_vm._e(),_vm._t("default"),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }